import { createSlice } from '@reduxjs/toolkit';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------
// Auth initial state
const initialState: {
  mode: 'light' | 'dark' | 'auto';
} = {
  mode: 'light',
};

const slice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    // --------------------------------------------------------------
    changeMode(state, action) {
      if (['light', 'dark', 'auto'].includes(action.payload)) {
        state.mode = action.payload;
      }
    },
  },
});

// Reducer
export default slice.reducer;

export function changeThemeMode(mode: 'light' | 'dark' | 'auto') {
  return async () => {
    dispatch(slice.actions.changeMode(mode));
  };
}
